import produce from 'immer';
import { LOAD_APPADMINS_FAILURE, LOAD_APPADMINS_REQUEST, LOAD_APPADMINS_SUCCESS, } from './constants';
export var initialState = {
    appAdmins: false,
    appAdminsList: [],
    loading: false,
    error: '',
    meta: {},
};
function appAdminsReducer(currentState, action) {
    if (currentState === void 0) { currentState = initialState; }
    return produce(currentState, function (state) {
        switch (action.type) {
            case LOAD_APPADMINS_REQUEST:
                state.loading = true;
                state.error = '';
                break;
            case LOAD_APPADMINS_SUCCESS:
                state.appAdminsList = action.appAdmins;
                state.meta = action.meta;
                state.loading = false;
                state.error = '';
                break;
            case LOAD_APPADMINS_FAILURE:
                state.loading = false;
                state.error =
                    'Something went wrong while fetching App Admins! Please try again';
                break;
            default:
                break;
        }
    });
}
export default appAdminsReducer;
